import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";

import { SocketContext } from "../../../context/socket";

const ChannelSummaryAlertComponent = (props) => {
  const { getAlerts, streamId, channelId, inDrawer = false } = props;
  const [alerts, setAlerts] = useState([]);
  const [load, setLoad] = useState(false);
  const { webhookSocket } = useContext(SocketContext);

  const antIcon = <LoadingOutlined style={{ fontSize: 30, align: "center" }} spin />;

  // common api call for fetching alerts in side drawer and channel summary page

  const fetchAlerts = async () => {
    setLoad(true);
    // if channel is not active, api call is skipped
    if (channelId.length) {
      try {
        const alerts = await getAlerts({
          channelId: channelId,
          streamId: streamId,
        });
        setAlerts(alerts.value.data);
      } catch (error) {
        notification["error"]({ message: "Something went wrong" });
      }
    }
    setLoad(false);
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  useEffect(() => {
    webhookSocket.on(`medialiveAlert${streamId}`, () => {
      fetchAlerts();
    });

    return () => {
      webhookSocket.off(`medialiveAlert${streamId}`);
    };
  }, [webhookSocket, streamId]);

  return (
    <>
      <div className="container-fluid pt-3">
        <div className="white-block-container">
          <div className="header-block-cs">
            <h5 className="block-title-d">
              Alerts <span>({!load ? alerts.length : ""})</span>
            </h5>
          </div>

          {load ? (
            <div className="bg-loader-fade">
              <Spin className="fade-loader" indicator={antIcon} />
              <div className="loader-back-text"></div>
            </div>
          ) : alerts.length ? (
            <div className="alerts-container-table">
              <ul>
                <li className="cs-header">
                  <span>Time</span>
                  {!inDrawer && (
                    <React.Fragment>
                      <span>State</span>
                      <span>Pipeline</span>
                      <span>Type</span>
                    </React.Fragment>
                  )}
                  <span>Message</span>
                </li>
                {alerts.map((alert) => (
                  <li className="cs-list-items">
                    <span className="red">
                      {moment.utc(alert.alertDuration).local().format("YYYY-MMM-DD HH:mm:ss")}
                    </span>
                    {!inDrawer && (
                      <React.Fragment>
                        <span>{alert.alarmState}</span>
                        <span>{alert.pipeline}</span>
                        <span>{alert.alertType}</span>
                      </React.Fragment>
                    )}
                    <span>{alert.alertMessage}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="text-center  pt-5 pb-5">
              <h3>No Alerts found</h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ChannelSummaryAlertComponent;
